document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.js-sellers-container', {
    navigation: {
      nextEl: '.js-slider-arrow-next',
      prevEl: '.js-slider-arrow-prev'
    },
    pagination: {
      el: swiperSlider.pagination,
      type: "bullets",
      clickable: true
    },
    breakpoints: {
      320: {
        initialSlide: 1,
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      900: {
        initialSlide: 1,
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.js-sellers2-container', {
    navigation: {
      nextEl: '.js-slider-arrow-next',
      prevEl: '.js-slider-arrow-prev'
    },
    pagination: {
      el: swiperSlider.pagination,
      type: "bullets",
      clickable: true
    },
    breakpoints: {
      320: {
        initialSlide: 1,
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      900: {
        initialSlide: 1,
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.js-sellers3-container', {
    navigation: {
      nextEl: '.js-slider-arrow-next',
      prevEl: '.js-slider-arrow-prev'
    },
    pagination: {
      el: swiperSlider.pagination,
      type: "bullets",
      clickable: true
    },
    breakpoints: {
      320: {
        initialSlide: 1,
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      900: {
        initialSlide: 1,
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.js-sellers4-container', {
    navigation: {
      nextEl: '.js-slider-arrow-next',
      prevEl: '.js-slider-arrow-prev'
    },
    pagination: {
      el: swiperSlider.pagination,
      type: "bullets",
      clickable: true
    },
    breakpoints: {
      320: {
        initialSlide: 1,
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      900: {
        initialSlide: 1,
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  });
});

let sellersNav = document.querySelector('.js-sellers-container .slider__nav');
let arrowPrev = document.querySelector('.js-sellers-container .js-slider-arrow-prev');
let arrowNext = document.querySelector('.js-sellers-container .js-slider-arrow-next');

if (document.querySelector('.js-sellers-container .slider__wrapper').children.length <= 4 && sellersNav) { 
  sellersNav.classList.add('slider-nav-desktop-hide');
  arrowPrev.classList.add('slider-button-desktop-hide');
  arrowNext.classList.add('slider-button-desktop-hide');
}

let sellersNav2 = document.querySelector('.js-sellers2-container .slider__nav');
let arrowPrev2 = document.querySelector('.js-sellers2-container .js-slider-arrow-prev');
let arrowNext2 = document.querySelector('.js-sellers2-container .js-slider-arrow-next');

if (document.querySelector('.js-sellers2-container .slider__wrapper').children.length <= 4 && sellersNav2) { 
  sellersNav2.classList.add('slider-nav-desktop-hide');
  arrowPrev2.classList.add('slider-button-desktop-hide');
  arrowNext2.classList.add('slider-button-desktop-hide');
}

let sellersNav3 = document.querySelector('.js-sellers3-container .slider__nav');
let arrowPrev3 = document.querySelector('.js-sellers3-container .js-slider-arrow-prev');
let arrowNext3 = document.querySelector('.js-sellers3-container .js-slider-arrow-next');

if (document.querySelector('.js-sellers3-container .slider__wrapper').children.length <= 4 && sellersNav3) { 
  sellersNav3.classList.add('slider-nav-desktop-hide');
  arrowPrev3.classList.add('slider-button-desktop-hide');
  arrowNext3.classList.add('slider-button-desktop-hide');
}

let sellersNav4 = document.querySelector('.js-sellers4-container .slider__nav');
let arrowPrev4 = document.querySelector('.js-sellers4-container .js-slider-arrow-prev');
let arrowNext4 = document.querySelector('.js-sellers4-container .js-slider-arrow-next');

if (document.querySelector('.js-sellers4-container .slider__wrapper').children.length <= 4 && sellersNav4) { 
  sellersNav4.classList.add('slider-nav-desktop-hide');
  arrowPrev4.classList.add('slider-button-desktop-hide');
  arrowNext4.classList.add('slider-button-desktop-hide');
}